// @flow
import React from 'react'
import styled from 'styled-components'
import { TextField, Button, Checkbox } from '@medeo/components'
import { connect } from 'react-redux'
import { logIn } from '@medeo/user'

type Props = {
  onSubmit: () => void
}
const StyledForm = styled.form`
  display: grid;
  grid-gap: 0.5rem;
  justify-items: center;
  & label {
    height: 16px;
  }
`
class LogInForm extends React.Component<Props> {
  state = {}

  onSubmit = e => {
    e.preventDefault()
    const { elements } = e.currentTarget
    const logInInfo = {
      password: elements.namedItem('password').value,
      email: elements.namedItem('email').value,
      stayConnected: elements.namedItem('stayConnected').checked
    }
    this.props.onSubmit(logInInfo)
  }
  render = () => (
    <StyledForm onSubmit={this.onSubmit}>
      <TextField type="email" name="email" id="email" label="Adresse email" />
      <TextField
        type="password"
        name="password"
        id="password"
        label="Mot de passe"
      />
      <Checkbox
        type="checkbox"
        name="stayConnected"
        id="stayConnected"
        label="Rester connecté"
      />
      <Button color="primary">Connexion</Button>
    </StyledForm>
  )
}

const mapDispatchToProps = dispatch => ({
  onSubmit: inputs => dispatch(logIn(inputs))
})

export default connect(undefined, mapDispatchToProps)(LogInForm)



// WEBPACK FOOTER //
// ./src/LogIn/containers/LogInForm.js